import { PublicClientApplication } from "@azure/msal-browser";
import { service, factories, models } from "powerbi-client";

let msalInstance = null;

const graphScopes = ["User.Read"];
const loginScopes = ["User.Read"];

// Alleen om een redirect-loop te voorkomen na een mislukte terugkomst.
// Wordt gewist na succes OF nadat de knop weer getoond is,
// zodat een volgend bezoek (bijv. via HelloID) opnieuw auto mag inloggen.
const pendingRedirectKey = "msal:pending-redirect";

function clearAuthFlags() {
    sessionStorage.removeItem(pendingRedirectKey);
    sessionStorage.removeItem("msal:silent-redirect-attempted");
    sessionStorage.removeItem("msal:interactive-redirect-attempted");
    sessionStorage.removeItem("msal:auto-login-attempted");
}

function showAuthenticatedUi(account) {
    document.getElementById("user").innerText = account.username;
    document.getElementById("loginButton").style.display = "none";
    document.getElementById("reportContainer").style.display = "block";
    document.getElementById("infoBlocks").style.display = "flex";
}

function showLoginButton() {
    clearAuthFlags();
    document.getElementById("loginButton").style.display = "";
    document.getElementById("loginButton").disabled = false;
}

async function initializeMsal() {
    document
        .getElementById("loginButton")
        .addEventListener("click", login);

    document.getElementById("reportContainer").style.display = "none";
    document.getElementById("infoBlocks").style.display = "none";
    document.getElementById("user").innerText = "";
    document.getElementById("loginButton").style.display = "none";

    const response = await fetch("/api/config");
    const config = await response.json();

    msalInstance = new PublicClientApplication({
        auth: {
            clientId: config.clientId,
            authority: `https://login.microsoftonline.com/${config.tenantId}`,
            redirectUri: config.redirectUri
        }
    });

    await msalInstance.initialize();

    let redirectHandled = false;
    try {
        const loginResponse = await msalInstance.handleRedirectPromise();
        redirectHandled = true;

        if (loginResponse?.account) {
            msalInstance.setActiveAccount(loginResponse.account);
            clearAuthFlags();
        }
    } catch (error) {
        redirectHandled = true;
        console.log(
            "Redirect login niet stil gelukt:",
            error?.errorCode || error?.message
        );
    }

    const account =
        msalInstance.getActiveAccount() ||
        msalInstance.getAllAccounts()[0] ||
        null;

    if (account) {
        msalInstance.setActiveAccount(account);
        clearAuthFlags();
        showAuthenticatedUi(account);
        loadReport().catch(console.error);
        return;
    }

    // Geen account: zelfde actie als de Inloggen-knop.
    // Geen ssoSilent meer — die is traag en faalt vaak vanuit HelloID.
    const pendingRedirect = sessionStorage.getItem(pendingRedirectKey) === "true";

    if (pendingRedirect && redirectHandled) {
        // We kwamen terug van een redirect zonder account → toon knop, reset flags.
        showLoginButton();
        return;
    }

    sessionStorage.setItem(pendingRedirectKey, "true");
    await login();
}

async function login() {
    await msalInstance.loginRedirect({
        scopes: loginScopes
    });
}

async function loadReport() {
    const account = msalInstance.getActiveAccount();
    if (!account) throw new Error("No active MSAL account");

    const tokenResponse = await msalInstance.acquireTokenSilent({
        scopes: graphScopes,
        account
    });

    const response = await fetch("/api/embed", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenResponse.accessToken}`
        },
        body: JSON.stringify({})
    });

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(`Embed endpoint failed (${response.status}): ${text}`);
    }

    const config = await response.json();

    const embedConfig = {
        type: "report",
        id: config.reportId,
        embedUrl: config.embedUrl,
        accessToken: config.embedToken,
        tokenType: models.TokenType.Embed
    };

    const reportContainer = document.getElementById("reportContainer");

    const powerbiService = new service.Service(
        factories.hpmFactory,
        factories.wpmpFactory,
        factories.routerFactory
    );

    powerbiService.embed(reportContainer, embedConfig);
}

(async () => {
    try {
        await initializeMsal();
    } catch (err) {
        console.error(err);
        showLoginButton();
    }
})();
